/* @flow */

import useAuthenticationToken from './useAuthenticationToken';

export default function useIsLogged(): ?string {
  return !!useAuthenticationToken();
}
